export enum PasswordResetChallenge {
    DOB = 'DOB',
    SecurityQuestions = 'SecurityQuestions'
}
